module.exports = __webpack_public_path__ + "img/四校戦 3.9079965d.jpg";